import styled from 'styled-components';

export const HeaderWrap = styled.header`
	width: 100%;
	position: relative;
`;

export const HeaderFixed = styled.div`
	position: fixed;
	height: 71px;
	z-index: 4;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 0 10px 80px;
	background-color: #fff;
	border-bottom: 1px solid #bddee3;
	max-width: 1020px;
	width: calc(100% - 260px);
	padding-right: 28px;
`;

export const LogoutWrapper = styled.div`
	margin-left: auto;
`;

export const Space = styled.div`
	flex: 1 0 auto;
`;
